import axios from "axios";
import settings from "../../settings";
axios.defaults.baseURL = settings.baseUrl;

export const getCorporateSignatures = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get("corporateSignature")
      .then(resp => {
        const response = resp.data;
        commit("SET_CORPORATE_SIGNATURES", response);
        resolve(response);
      })
      .catch(err => {
        commit("SET_CORPORATE_SIGNATURES", []);
        reject(err);
      });
  });
};

// eslint-disable-next-line no-unused-vars
export const uploadCorporateSignature = ({ commit }, params) => {
  const formData = new FormData();
  formData.append("description", params.description);
  formData.append("password", params.password);
  formData.append("certificate", params.certificate, params.certificate.name);

  return new Promise((resolve, reject) => {
    axios
      .post("corporateSignature", formData)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};

// eslint-disable-next-line no-unused-vars
export const updateCorporateSignature = ({ commit }, params) => {
  const formData = new FormData();
  formData.append("description", params.description);
  formData.append("password", params.password);
  formData.append("certificate", params.certificate, params.certificate.name);

  return new Promise((resolve, reject) => {
    axios
      .put("corporateSignature/" + params.corporateSignatureId, formData)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};

// eslint-disable-next-line no-unused-vars
export const deleteCorporateSignature = ({ commit }, id) => {
  console.log("entering delete corporate signature");
  return new Promise((resolve, reject) => {
    axios
      .delete("corporateSignature/" + id)
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
};
